module.exports = __webpack_public_path__ + "img/911.8d999230.png";